import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import {
  Card,
  Container,
  Typography,
  Stack,
  Grid,
  MenuItem,
  Box,
  FormControl,
  Button,
} from '@mui/material';
// hooks
// components
// sections
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { addDoc, collection, doc, getDoc, getDocs, query, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';

import * as Yup from 'yup';
import { useEffect, useState } from 'react';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import CustomButton from '../components/CustomButton';
import { UserAuth } from '../context/AuthContext';
import Iconify from '../components/Iconify';
import { RHFTextField, FormProvider, RHFCheckbox } from '../components/hook-form';
import Logo from '../components/Logo';
import Page from '../components/Page';
import useResponsive from '../hooks/useResponsive';
import { db } from '../firebase.config';
import RHFSelect from '../components/hook-form/RHFSelect';
import CustomNumber from '../components/customNumber';
import CustomStepper from '../components/customStepper';
import { RHFCustomNumber } from '../components/hook-form/RHFCustomNumber';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  // position: "fixed",
  maxWidth: '35%',
  display: 'flex',
  background: 'linear-gradient(217deg, #5516CA, rgba(255,0,0,0) 100.71%), linear-gradient(127deg, #e66465, rgba(0,255,0,0) 60.71%), linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%)',
  flexDirection: 'column',
  justifyContent: 'center',
  // margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 500,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(0, 0),
  paddingTop: 20,
  paddingBottom: 20
}));

// ----------------------------------------------------------------------

export default function RegisterOrg() {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  // *******************************************************************

  const { user, signUp, logOut, signUpSecondStep, userData } = UserAuth();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [id, setId] = useState();
  const [statusJur, setStatus] = useState();
  const [num, setNum] = useState();
  const [numError, setNumError] = useState({ status: false, msg: '' });
  const [code, setCode] = useState();
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [implentations, setImplentations] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [certifie, setCert] = useState();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // upload functions
  const [selectedImage, setSelectedImage] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [selectedBanner, setSelectedBanner] = useState();
  const [BannerUrl, setBannerUrl] = useState();

  const RegisterOrgSchema = Yup.object().shape({
    statusJur: Yup.string().required("Le type d'organisation est obligatoire"),
    nom: Yup.string().when('statusJur', {
      // ⚠️ Nom obligatoire seulement si ce n'est PAS un particulier
      is: (val) => val !== 'Particulier',
      then: (schema) => schema.required("Le nom de l'organisation est obligatoire"),
      otherwise: (schema) => schema.notRequired(),
    }),
    ville: Yup.string().required('La ville est obligatoire'),
    pays: Yup.string().required('Le pays est obligatoire'),
    tel: Yup.string()
      .trim()
      .required('Le numéro de téléphone est obligatoire'),
    confirmed: Yup.boolean().oneOf([true], 'Vous devez accepter les conditions'),
  });

  const defaultValues = {
    statusJur: '',   // ⬅ même casse que dans le schéma + dans le formulaire
    nom: '',
    ville: '',
    pays: '',
    tel: '',
    confirmed: false,
  };



  const methods = useForm({
    resolver: yupResolver(RegisterOrgSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (e) => {
    const userId = user.uid;
    const orgaRef = doc(db, 'organisateurs', userId);
    const userRef = doc(db, 'users', userId);
    let tmpOrgId;
    console.log(user)
    setNumError({})

    try {
      
      // 📌 Étape 1 : Vérifier si l'organisateur existe
      const baseRoleId = 'jzPWX2jyVDsi2oKG6Edw';
      const orgaSnap = await getDoc(orgaRef);
      const userSnap = await getDoc(userRef);

      if (!orgaSnap.exists()) {
        // ➕ Créer le doc "organisateurs"
        await setDoc(orgaRef, {
          id: userId,
          dateCreation: serverTimestamp(),
          email: user.email,
          isOrg: true,
        });
      }

      // 📌 Étape 2 : Vérifier ou créer l'organisation liée
      const idOrg = orgaSnap.data()?.idOrg;

      if (!idOrg) {
        const newOrgRef = await addDoc(collection(db, 'organisations'), {
          dateCreation: serverTimestamp(),
        });

        tmpOrgId = newOrgRef.id;

        const permRef = await addDoc(collection(db, `organisations/${tmpOrgId}/roles`), {
          permissionId: baseRoleId,
        });

        const roleId = permRef.id

        await updateDoc(orgaRef, { idOrg: tmpOrgId, roleId });
        await updateDoc(userRef, { idOrg: tmpOrgId });
      } else {
        tmpOrgId = idOrg;
      }

      const storage = getStorage();
      let logoURL = '';
      let bannerURL = '';

      if (selectedImage) {
        const logoRef = ref(storage, `organisations/${tmpOrgId}/logo`);
        await uploadBytes(logoRef, selectedImage);
        logoURL = await getDownloadURL(logoRef);
      }

      if (selectedBanner) {
        const bannerRef = ref(storage, `organisations/${tmpOrgId}/banner`);
        await uploadBytes(bannerRef, selectedBanner);
        bannerURL = await getDownloadURL(bannerRef);
      }


      // 📌 Étape 3 : Mettre à jour l'organisation
      const orgRef = doc(db, 'organisations', tmpOrgId);
      const coordRef = doc(db, `organisations/${tmpOrgId}/coordonnee`, tmpOrgId);
      const nomCompletUser = `${userSnap.data()?.nom || ''} ${userSnap.data()?.prenom || ''}`.trim();

    const nomOrganisation =
      e.statusJur === 'Particulier'
        ? nomCompletUser                       // 👈 ce que tu veux
        : (e.nom || '').trim();  

      await Promise.all([
        updateDoc(orgRef, {
          representantId: userId,
          type: e.statusJur === 'Particulier' ? 0 : 1,
          kycStatus: 0,
          status: 0,
          nomOrg: nomOrganisation,
          name: nomOrganisation.toLowerCase(),
          updateDate: serverTimestamp(),
          certified: true,
          idVisuel: logoURL || null,
          bannerVisuel: bannerURL || null,
          location: { country: e.pays.trim(), city: e.ville.trim() },
          infoLine: { email: null, tel: e.tel.trim() }
        }),

      ]);

      // ✅ Étape 4 : Redirection
      window.location.href = "/bo";


    } catch (error) {
      console.error("Erreur lors de la soumission :", error);
    }
  };

  const handleStatus = (e) => {
    setStatus(e.target.value)

    // navigate('/bo', { replace: true });
  };

  const watchedCountry = watch('pays');
  const watchedStatus = watch("statusJur");

  useEffect(() => {
    if (watchedCountry) {
      handleCountry({ target: { value: watchedCountry } });
    }
  }, [watchedCountry]);

  const handleCountry = (e) => {
    const countryName = e.target.value;
    setSelectedCountry(countryName);

    const selectedImplentation = implentations.find((item) => item.name === countryName);

    if (selectedImplentation) {
      setCity(selectedImplentation.villes || []);
      setSelectedCity(''); // reset la ville si le pays change
    } else {
      setCity([]);
    }
  };

  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);
  useEffect(() => {
    if (selectedBanner) {
      setBannerUrl(URL.createObjectURL(selectedBanner));
    }
  }, [selectedBanner]);

  useEffect(() => {
    (async () => {
      try {

        setLoading(true);
        // verification de l'existance du compte
        /* navigate('/bo', { replace: true }); */
        console.log(user);
        const tmp = []
        const q = query(collection(db, 'implentations'));
        const docSnap = await getDocs(q);
        docSnap.forEach((element) => {
          // etImplentations((implentations) => [...implentations, element.data()]);
          tmp.push(element.data())
        });
        setImplentations(tmp)
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false)
      }
    })();
  }, []);

  const handleLogout = async () => {
    try {
      await logOut();
      window.location.reload();
    } catch (error) {
      console.log(error);
      window.location.reload();
    }
  };


  return (
    <Page title="Inscription">
      <RootStyle>
        <HeaderStyle>
          <Logo />
        </HeaderStyle>

        <Container>
          <ContentStyle>
            <Typography variant="h5" gutterBottom textAlign={'center'}>
              Créer une organisation
            </Typography>
            <CustomStepper activeStep={1} />

            <Typography variant='body2' sx={{ color: 'text.secondary', mb: 4 }}>Gérer ses événements, son équipe, ses campagnes marketing et ses ventes de billets depuis un espace centralisé.
            </Typography>



            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={2}>

                <Button
                  fullWidth
                  size="medium"
                  sx={{
                    textTransform: 'initial',
                    boxShadow: 'none',
                    border: '1px dashed #d4d4d4ff',
                    color: 'black',
                    borderRadius: 8,
                    padding: 0,
                    overflow: 'hidden',
                    backgroundColor: '#f2f2f2',
                    '&:hover': {
                      backgroundColor: '#f2f2f2',
                      color: '#5E17EB',
                      borderColor: '#5E17EB',
                    },
                  }}
                  variant="contained"
                  component="label"
                >
                  <input
                    hidden
                    accept="image/*"
                    id="select-image"
                    type="file"
                    onChange={(e) => setSelectedBanner(e.target.files[0])}
                  />

                  {BannerUrl ? (
                    <Box width="100%">
                      <img
                        src={BannerUrl}
                        alt="Bannière"
                        style={{
                          width: '100%',
                          height: '120px',
                          objectFit: 'cover',
                          borderRadius: 8,
                          display: 'block',
                        }}
                      />
                    </Box>
                  ) : (
                    <Stack justifyContent="center" alignItems="center" spacing={1} py={2} width="100%">
                      {loading ? (
                        <Typography variant="body2">Chargement...</Typography>
                      ) : (
                        <>
                          <Iconify icon="material-symbols:upload" sx={{ width: 30, height: 30 }} />
                          <Typography textAlign="center" variant="subtitle2">
                            Cliquer ici pour charger une image comme bannière
                          </Typography>
                          <Typography textAlign="center" variant="caption">
                            Seuls les fichiers image (.jpg, .png, .webp...) sont acceptés
                          </Typography>
                        </>
                      )}
                    </Stack>
                  )}
                </Button>
                <Box display="flex" justifyContent="center" mt={0} padding={0}>
                  <Button
                    component="label"
                    variant="contained"
                    sx={{
                      width: 85,
                      height: 85,
                      borderRadius: '50%',
                      padding: 0,
                      overflow: 'hidden',
                      border: '1px dashed #d4d4d4ff',
                      backgroundColor: '#f2f2f2',
                      color: 'black',
                      boxShadow: 'none',
                      textTransform: 'initial',
                      '&:hover': {
                        backgroundColor: '#f2f2f2',
                        color: '#5E17EB',
                        borderColor: '#5E17EB',
                      },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(e) => setSelectedImage(e.target.files[0])}
                    />

                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="logo"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '50%',
                        }}
                      />
                    ) : (
                      <Stack spacing={1} alignItems="center">
                        {loading ? (
                          <Typography variant="caption">Chargement...</Typography>
                        ) : (
                          <>
                            <Iconify icon="material-symbols:upload" sx={{ width: 30, height: 30 }} />
                            <Typography variant="caption" textAlign="center">
                              Logo
                            </Typography>
                          </>
                        )}
                      </Stack>
                    )}
                  </Button>
                </Box>

                <FormControl fullWidth>
                  <RHFSelect displayEmpty name="statusJur" renderValue={(value) =>
                    value || <span style={{ color: '#657382' }}>Type d'organisation</span>
                  } >
                    <MenuItem disabled value="">
                      Selectionner un type d'organisation
                    </MenuItem>
                    <MenuItem key={1} value={'Entreprise'}>
                      Entreprise
                    </MenuItem>
                    <MenuItem key={0} value={'Particulier'}>
                      Particulier
                    </MenuItem>
                  </RHFSelect>
                </FormControl>

                {
                  watchedStatus !== 'Particulier' &&
                  <RHFTextField name="nom" label="Nom de l'organisation" />


                }
                <Grid container gap={3}>
                  <Grid item xs={12} sm={5.5}>
                    <FormControl disabled={loading} error fullWidth>

                      <RHFSelect displayEmpty name="pays" renderValue={(value) =>
                        value || <span style={{ color: '#657382' }}>Pays</span>
                      } >
                        <MenuItem disabled value="">
                          Sélectionner un pays
                        </MenuItem>
                        {implentations.map((option, index) => (
                          <MenuItem key={option.countryCode} value={option.name}>
                            {`${option.name} (${option.countryCode})`}
                          </MenuItem>
                        ))}
                      </RHFSelect>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={5.9}>
                    <FormControl fullWidth>

                      <RHFSelect displayEmpty name="ville" renderValue={(value) =>
                        value || <span style={{ color: '#657382' }}>Ville</span>
                      }>
                        <MenuItem disabled value="">
                          Sélectionner une ville
                        </MenuItem>
                        {city.map((option, index) => (
                          <MenuItem key={option.id || option.name} value={option.name}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </RHFSelect>
                    </FormControl>
                  </Grid>
                </Grid>


                <RHFCustomNumber name="tel" />
                <RHFCheckbox name="confirmed" label="je certifie sur l'honneur l'exactitude des informations ci-dessus." />
                <LoadingButton
                  sx={{
                    textTransform: 'initial',
                    border: '2px solid transparent',
                    color: 'white',
                    backgroundColor: '#5E17EB',
                    boxShadow: 0,
                    borderRadius: '7px',
                    '&:hover': {
                      backgroundColor: 'white',
                      color: '#5E17EB',
                      borderColor: '#5E17EB',
                    },
                  }}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  loading={loading}
                >
                  Continuer
                </LoadingButton>
                <CustomButton type={'secondaire'} buttonText={`Se deconnecter du compte ${user.email}`} onClick={handleLogout} />
              </Stack>
            </FormProvider>
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
